import React, {ReactNode} from 'react';

import {FloatingPlacement, FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';
import HelpIcon from 'ui-library/icons/HelpIcon';

export interface HelpButtonProps {
  renderContent: () => ReactNode;
  iconClassName?: string;
  placement?: FloatingPlacement;
  interaction?: FloatingInteraction.CLICK | FloatingInteraction.HOVER;
  title?: string;
}

export default function HelpButton({
  iconClassName,
  interaction = FloatingInteraction.CLICK,
  placement = FloatingPlacement.RIGHT,
  renderContent,
  title,
}: HelpButtonProps): JSX.Element {
  return (
    <Popover interaction={interaction} renderContent={renderContent} title={title} placement={placement}>
      <HelpIcon className={iconClassName} />
    </Popover>
  );
}
